import { useState } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

export interface ModalsState {
  isAddMemberOpen: boolean
  onOpenAddMember: () => void
  onCloseAddMember: () => void
  isEditOpen: boolean
  onOpenEdit: () => void
  onCloseEdit: () => void
  isRemoveOpen: boolean
  onOpenRemove: () => void
  onCloseRemove: () => void
}

const useModals = (): ModalsState => {
  const [isAddMemberOpen, setAdd] = useState(false)
  const [isEditOpen, setEdit] = useState(false)
  const [isRemoveOpen, setRemove] = useState(false)

  const { addTeamDetailsMembersStart, goToEditTeamInformation, goToDeleteTeamInformation } =
    trackingEvents.teams
  const onOpenAddMember = () => {
    track(addTeamDetailsMembersStart)
    setAdd(true)
  }
  const onCloseAddMember = () => {
    setAdd(false)
  }

  const onOpenEdit = () => {
    track(goToEditTeamInformation)
    setEdit(true)
  }

  const onCloseEdit = () => {
    setEdit(false)
  }

  const onOpenRemove = () => {
    track(goToDeleteTeamInformation)
    setRemove(true)
  }
  const onCloseRemove = () => {
    setRemove(false)
  }
  return {
    isAddMemberOpen,
    onOpenAddMember,
    onCloseAddMember,
    isEditOpen,
    onOpenEdit,
    onCloseEdit,
    isRemoveOpen,
    onOpenRemove,
    onCloseRemove,
  }
}
export default useModals
